import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';
import { NextFlipLogo } from './Logo';
import { SupportButton } from './SupportButton';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    marketplace: [
      { label: 'Browse Deals', href: '/marketplace' },
      { label: 'Post a Deal', href: '/post-deal' },
      { label: 'How It Works', href: '/' }
    ],
    directory: [
      { label: 'Find Providers', href: '/directory' },
      { label: 'Realtors', href: '/directory?category=Realtor' },
      { label: 'Contractors', href: '/directory?category=Contractor' },
      { label: 'Lenders', href: '/directory?category=Hard Money Lender' }
    ],
    markets: [
      { label: 'Cleveland - Investors', href: '/markets/cleveland/investors' },
      { label: 'Cleveland - Wholesalers', href: '/markets/cleveland/wholesalers' },
      { label: 'Cleveland - Agents', href: '/markets/cleveland/agents' },
      { label: 'Cleveland - Providers', href: '/markets/cleveland/providers' }
    ],
    forYou: [
      { label: 'For Investors', href: '/for-investors' },
      { label: 'For Agents & Brokers', href: '/for-agents' },
      { label: 'For Service Providers', href: '/for-providers' }
    ],
    company: [
      { label: 'About Us', href: '/' },
      { label: 'Privacy Policy', href: '/' },
      { label: 'Terms of Service', href: '/' }
    ]
  };

  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6">
        {/* Main Footer */}
        <div className="py-16 grid md:grid-cols-6 gap-12">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <NextFlipLogo size="default" />
            </Link>
            <p className="text-slate-400 leading-relaxed mb-6">
              The marketplace for real estate investors to find off-market deals and connect with trusted service providers.
            </p>
            <div className="flex gap-4">
              <a href="mailto:hello@nextflip.com" className="text-slate-400 hover:text-white transition-colors">
                <Mail className="h-5 w-5" />
              </a>
              <a href="tel:+1-555-123-4567" className="text-slate-400 hover:text-white transition-colors">
                <Phone className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Marketplace Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Marketplace</h4>
            <ul className="space-y-3">
              {footerLinks.marketplace.map(link => (
                <li key={link.href}>
                  <Link to={link.href} className="text-slate-400 hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Directory Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Directory</h4>
            <ul className="space-y-3">
              {footerLinks.directory.map(link => (
                <li key={link.href}>
                  <Link to={link.href} className="text-slate-400 hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Markets Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Markets</h4>
            <ul className="space-y-3">
              {footerLinks.markets.map(link => (
                <li key={link.href}>
                  <Link to={link.href} className="text-slate-400 hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* For You Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">For You</h4>
            <ul className="space-y-3">
              {footerLinks.forYou.map(link => (
                <li key={link.href}>
                  <Link to={link.href} className="text-slate-400 hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map(link => (
                <li key={link.href + link.label}>
                  <Link to={link.href} className="text-slate-400 hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <SupportButton variant="link" />
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {currentYear} NextFlip. All rights reserved.
          </p>
          <p className="text-slate-500 text-sm">
            Built for real estate investors.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
